export default __webpack_public_path__ + "static/media/img--interiors-4.9678d5d7.jpg";